import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Modal,
  CloseButton,
  Spinner,
} from "react-bootstrap";
import {
  prescription,
  useEditPrescription,
  useMedicines,
  usePrescription,
} from "./store";
import isEmpty from "lodash/isEmpty";
import { cannotCreateStatus } from "../../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  canWritePrescription,
  getCurrentUserRole,
} from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";

function CreatePrescription({
  prescriptionData,
  orderId,
  order,
  dosages = [],
  editFlag = false,
  show = true
}) {
  const [medicine, setMedicine] = useState("");
  const [dosage, setDosage] = useState("");
  const [note, setNote] = useState("");
  const [prescriptionItems, setPrescriptionItems] = useState([]);
  const { medicinesData, medicines } = useMedicines();
  const [canCreate, setCanCreate] = useState(true);
  const [hasWritten, setHasWritten] = useState(false);
  const { prescriptionLoading, setPrescription } = prescription();
  const [recommendedMedicine, setRecommendedMedicine] = useState("");
  const { fetchPrescriptionData } = usePrescription();
  const [completeDosage, setCompleteDosage] = useState([]);
  const [medicineObject, setMedicineObject] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [deleteComment, setDeleteComment] = useState("");
  const { editLoading, editPrescription } = useEditPrescription();
  const [addedItem, setAddItem] = useState([]);
  const [removeItem, setRemoveItem] = useState([]);
  const [index, setIndex] = useState(undefined);
  const [createAccess, setCreateAccess] = useState(false);

  useEffect(() => {
    setCompleteDosage(
      dosages?.sort((a, b) => {
        const typeOrder = { ayurveda: 1, combo: 2, allopathy: 3 };
        return typeOrder[a.type] - typeOrder[b.type];
      })
    );
  }, [dosages]);

  useEffect(() => {
    if(show){
      medicinesData();
    }
  }, [show]);

  useEffect(() => {
    if (canWritePrescription.includes(getCurrentUserRole())) {
      setCreateAccess(true);
    } else {
      setCreateAccess(false);
    }
  }, []);

  useEffect(() => {
    setCanCreate(() => !cannotCreateStatus.includes(order.status));
  }, [order.status]);

  useEffect(() => {
    if (isEmpty(prescriptionData)) setHasWritten(false);
    else {
      const prescription = prescriptionData.filter(
        (prescriptionData) => prescriptionData.order_id === order.id
      );
      setHasWritten(
        prescription.some(
          (somePrescriptionData) =>
            somePrescriptionData.user_id === secureLocalStorage.getItem("id")
        )
      );
    }
  }, [order.id, prescriptionData]);

  useEffect(() => {
    if (!modalShow && index >= 0) {
      const updatedPrescriptionItems = [...prescriptionItems];
      updatedPrescriptionItems.splice(index, 1);
      const removePrescription = completeDosage[index];
      setRemoveItem((prev) => [
        ...prev,
        { ...removePrescription, reason: deleteComment },
      ]);
      completeDosage.splice(index, 1);
      setPrescriptionItems(updatedPrescriptionItems);
      setIndex(undefined);
      setDeleteComment("");
    }
  }, [modalShow]);

  const handleMedicineChange = (selectedMedicineName) => {
    const selectedMedicineObject = medicines.find(
      (medicineOption) => medicineOption.display_name === selectedMedicineName
    );

    if (selectedMedicineObject) {
      setMedicine(selectedMedicineName);
      setDosage(selectedMedicineObject.dosage);
    } else {
      setMedicine("");
      setDosage("");
    }
  };

  const handleAddRecommendedMedicine = () => {
    setCompleteDosage((prevCompleteDosage) => [
      ...prevCompleteDosage,
      {
        display_name: medicine,
        dosage: dosage,
        note: note,
      },
    ]);
    setAddItem((prev) => [
      ...prev,
      {
        display_name: medicine,
        dosage: dosage,
        note: note,
      },
    ]);
    setMedicine("");
    setDosage("");
    setNote("");
    setRecommendedMedicine("");
  };

  const handleRemoveFromPrescription = (index) => {
    setModalShow(true);
    setIndex(index);
  };

  const getMedicineObject = (medicineItem) =>{
  return  medicines.find(
      (medicineOption) =>
        medicineOption.display_name ===
        (medicineItem.display_name || medicineItem?.Medicine)
    );
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    let updatedPrescriptionItems = [];
    let selectedMedicines = [];
    let addMedicineItem = [];
    completeDosage.forEach((medicineItem, index) => {
      const selectedMedicineObject = getMedicineObject(medicineItem);
      selectedMedicines.push(selectedMedicineObject);
      const isRecommended = !dosages.some(
        (dosageOption) =>
          dosageOption.display_name === medicineItem.display_name
      );
      if (selectedMedicineObject) {
        setMedicine(medicineItem.display_name || medicineItem?.Medicine);
        setDosage(medicineItem.dosage || medicineItem.Dosage);
        const selectedMedicineName =
          medicineItem?.display_name || medicineItem?.Medicine;
        const prescriptionItem = {
          composition: selectedMedicineObject.composition,
          description: selectedMedicineObject.description,
          Dosage:
            medicineObject[selectedMedicineName] &&
            medicineObject[selectedMedicineName].dosage
              ? medicineObject[selectedMedicineName].dosage
              : selectedMedicineObject.dosage,
          info: selectedMedicineObject.info,
          is_composition: selectedMedicineObject.is_composition,
          Medicine: selectedMedicineObject.display_name,
          showRecommendation: isRecommended,
          type: selectedMedicineObject.type,
          key: selectedMedicineObject.id,
          note:
            medicineObject[selectedMedicineName] &&
            medicineObject[selectedMedicineName].note
              ? medicineObject[selectedMedicineName].note
              : medicineItem?.note,
        };
        if (editFlag && medicineItem?.product_principal_id) {
          prescriptionItem.product_principal_id =
            medicineItem?.product_principal_id || "";
        }
        if(medicineItem?.quantity){
          prescriptionItem.quantity =
          medicineItem?.quantity || "";
        }

        updatedPrescriptionItems.push(prescriptionItem);
        //Added added item inside payload
        addedItem?.map((medicine) => {
          if (medicine.display_name == selectedMedicineObject?.display_name) {
            addMedicineItem.push({
              name: selectedMedicineObject.display_name,
              id: selectedMedicineObject.id,
              note:
                medicineObject[selectedMedicineName] &&
                medicineObject[selectedMedicineName].note
                  ? medicineObject[selectedMedicineName].note
                  : note,
              reason:
                medicineObject[selectedMedicineName] &&
                medicineObject[selectedMedicineName].note
                  ? medicineObject[selectedMedicineName].note
                  : note,
            });
          }
        });
        // Clear medicine, dosage, and note for the next iteration
        setMedicine("");
        setDosage("");
        setNote("");
      }
    });
    //Removed medicine from automated prescription
    const removeMedicineItem = removeItem?.map((medicine, index) => {
      const medicineObject = getMedicineObject(medicine);
      return {
        name: medicine.display_name || medicine.Medicine,
        id: medicineObject?.id || medicineObject?.key,
        note: medicine?.note,
        reason: medicine?.reason || "",
      };
    });

    const prescriptionObject = {
      prescription: updatedPrescriptionItems,
    };
    const editDataFlag = editFlag ? orderId : order?.id;

    editFlag
      ? editPrescription(
          editDataFlag,
          {
            prescription: prescriptionObject,
            orderEdit: {
              add: [...new Set(addMedicineItem)],
              remove: [...new Set(removeMedicineItem)],
            },
            version: "2",
            doctorId: secureLocalStorage.getItem("id") || "",
          },
          toast,
          fetchPrescriptionData,
          order.case_id
        )
      : setPrescription(
          order.id,
          {
            prescription: prescriptionObject,
            orderEdit: {
              add: [...new Set(addMedicineItem)],
              remove: [...new Set(removeMedicineItem)],
            },
            version: "2",
            doctorId: secureLocalStorage.getItem("id") || "",
          },
          toast,
          fetchPrescriptionData,
          order.case_id
        );

    setMedicine("");
    setDosage("");
    setNote("");
    setDeleteComment([]);
    setPrescriptionItems([]);
    setAddItem([]);
    setRemoveItem([]);
    updatedPrescriptionItems = [];
    selectedMedicines = [];
    addMedicineItem = [];
  };

  const handleMedChange = (medicine, inputs) => {
    const { name, value } = inputs;
    setMedicineObject((prevMed) => {
      return {
        ...prevMed,
        [medicine]: {
          ...prevMed[medicine],
          [name]: value,
        },
      };
    });
  };

  const sortedMedicines = medicines
    .sort((a, b) => {
      const typeOrder = { ayurveda: 1, combo: 2, allopathy: 3 };
      return typeOrder[a.type] - typeOrder[b.type];
    })
    .filter((item) => (item?.type !== "ayurveda" && item?.type !== "combo"));

  const handleComment = (event) => {
    setDeleteComment(event.target.value);
  };

  const handleSave = () => {
    setModalShow(false);
  };

  const disableProduct = ["ayurveda", "combo"];

  const showTable = editFlag ? true : (canCreate || hasWritten) && createAccess;
  const isLoading = editFlag ? editLoading : prescriptionLoading;

  return (
    <>
      {showTable && (
        <>
          <div
            style={{ maxHeight: "25%", overflowY: "scroll" }}
            className="scrollable-container border rounded m-2 p-2 shadow"
          >
            {completeDosage.map((eachMed, index) => (
              <Form key={index} className="d-flex gap-2 align-items-center">
                <Row>
                  <Col>
                    <Form.Group className="mb-2">
                      <Form.Label>Medicine</Form.Label>
                      <Form.Control
                        value={eachMed?.Medicine || eachMed.display_name}
                        style={{ width: "15vw" }}
                        disabled={
                          disableProduct.includes(eachMed?.type) ? true : false
                        }
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Dosage</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Dosage"
                        name="dosage"
                        defaultValue={eachMed?.Dosage || eachMed?.dosage}
                        onChange={(event) => {
                          handleMedChange(
                            eachMed?.Medicine || eachMed?.display_name,
                            event.target
                          );
                        }}
                        disabled={
                          disableProduct.includes(eachMed?.type) ? true : false
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Note</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter note"
                        name="note"
                        defaultValue={eachMed.note ? eachMed.note : ""}
                        onChange={(event) => {
                          handleMedChange(
                            eachMed?.Medicine || eachMed.display_name,
                            event.target
                          );
                        }}
                        disabled={
                          disableProduct.includes(eachMed?.type) ? true : false
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  variant="danger"
                  onClick={() => handleRemoveFromPrescription(index)}
                  className="h-50 mt-3"
                  disabled={
                    disableProduct.includes(eachMed?.type) ||
                    isEmpty(completeDosage)
                      ? true
                      : false
                  }
                >
                  -
                </Button>
              </Form>
            ))}
          </div>
          <div
            style={{ maxHeight: "25%", overflowY: "scroll" }}
            className="scrollable-container border rounded m-2 p-2 shadow"
          >
            <Form className="d-flex gap-2 align-items-center">
              <Row>
                <Col style={{ width: "15vw" }}>
                  <Form.Group className="mb-3">
                    <Form.Label>Medicine</Form.Label>
                    <Form.Select
                      value={recommendedMedicine}
                      onChange={(event) => {
                        setRecommendedMedicine(event.target.value);
                        handleMedicineChange(event.target.value);
                      }}
                      className="flex-fill"
                      style={{ width: "14vw" }}
                    >
                      <option value="">Select Medicine</option>
                      {sortedMedicines?.map((medicineOption) => (
                        <option
                          key={medicineOption.id}
                          value={medicineOption.display_name}
                        >
                          {medicineOption.display_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Dosage</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Dosage"
                      value={dosage}
                      onChange={(event) => {
                        setDosage(event.target.value);
                        handleMedChange(recommendedMedicine, event.target);
                      }}
                      className="flex-fill"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Note</Form.Label>
                    <Form.Control
                      name="note"
                      type="text"
                      placeholder="Enter note"
                      value={note}
                      onChange={(event) => {
                        setNote(event.target.value);
                        handleMedChange(recommendedMedicine, event.target);
                      }}
                      className="flex-fill"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button
                variant="primary"
                onClick={handleAddRecommendedMedicine}
                className="h-50 mt-3"
                disabled={recommendedMedicine === ""}
              >
                +
              </Button>
            </Form>
          </div>
          <Button
            className="m-2 p-2"
            style={{ width: "15rem" }}
            type="submit"
            variant="primary"
            onClick={handleSubmit}
            hidden={isEmpty(completeDosage)}
          >
            {editFlag ? (
              isLoading ? (
                <span className="d-flex align-items-center justify-content-center gap-1">
                  <span>{<Spinner animation="border" size="sm" />}</span>
                  <span> Updating</span>
                </span>
              ) : (
                "Update Prescription"
              )
            ) : isLoading ? (
              <span className="d-flex align-items-center justify-content-center gap-1">
                <span> {<Spinner animation="border" size="sm" />}</span>
                <span>Saving</span>
              </span>
            ) : (
              "Save Prescription"
            )}
          </Button>
          <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ zIndex: "9999999" }}
          >
            <Modal.Header>
              <Modal.Title id="contained-modal-title-vcenter">
                Delete Notes
              </Modal.Title>
              <CloseButton
                className="btn btn-circle btn-sm transition-base p-0"
                onClick={() => setModalShow(false)}
              />
            </Modal.Header>
            <Modal.Body>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                placeholder="Delete Notes"
                onChange={(event) => handleComment(event)}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleSave}>Save</Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
}

export default CreatePrescription;
